export const AppAdExtension = {
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'AppAdExtension',
    },
  },
};
